var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.toggle}},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.microphone}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }